import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { crewHome, needsProfileCheck } from './lib/crewHome'

// ProtectedApp: 'yacht' | 'wait' | 'crew' | 'none' for the signed-in user (src/crew/lib/crewHome.js). Reads useAuth's state,
// never changes it. A failed check (e.g. before the migration has run) counts as no profile -> 'none' for a login without a
// vessel (it has nothing to see in the app either).
export function useCrewHome({ user, config, loading }) {
  const [profile, setProfile] = useState(undefined)
  const ask = needsProfileCheck({ user, config, loading })
  const uid = user && user.id
  useEffect(() => {
    if (!ask) { setProfile(undefined); return }
    let live = true
    supabase.rpc('crew_my_profile_id')
      .then(({ data, error }) => { if (live) setProfile(error ? null : data || null) }, () => { if (live) setProfile(null) })
    return () => { live = false }
  }, [ask, uid])
  return crewHome({ user, config, loading }, profile)
}
